module.exports = __webpack_public_path__ + "img/check.5fc30cd1.svg";